import { AllureMaterialRequestStateTypes, AllureMaterialRequestActionTypes } from "./AllureMaterialRequest.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: AllureMaterialRequestStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const AllureMaterialRequestReducer = (
  state: AllureMaterialRequestStateTypes = INITIAL_STATE,
  action: any
): AllureMaterialRequestStateTypes => {
  switch (action.type) {
    case AllureMaterialRequestActionTypes.FETCH_ALL_ALLURE_MATERIAL_REQUEST:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureMaterialRequestActionTypes.FETCH_ALL_ALLURE_MATERIAL_REQUEST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureMaterialRequestActionTypes.FETCH_ALL_ALLURE_MATERIAL_REQUEST_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureMaterialRequestActionTypes.FETCH_ALL_ALLURE_MATERIAL_REQUEST_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case AllureMaterialRequestActionTypes.FETCH_ONE_ALLURE_MATERIAL_REQUEST:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case AllureMaterialRequestActionTypes.FETCH_ONE_ALLURE_MATERIAL_REQUEST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case AllureMaterialRequestActionTypes.FETCH_ONE_ALLURE_MATERIAL_REQUEST_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case AllureMaterialRequestActionTypes.FETCH_ONE_ALLURE_MATERIAL_REQUEST_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default AllureMaterialRequestReducer;
